import { InterviewQuestionForEdit } from '../../../../../store/workspace/types'
import styles from './style.module.scss'
import Modal from '../../../../../components/Modal'
import { EditSquareIcon } from '../../../../../assets/icons'
import CheckBox from '../../../../../components/CheckBox'
import Button from '../../../../../components/Button'
import { Dispatch, SetStateAction, useState } from 'react'

interface Props {
    questions: InterviewQuestionForEdit[];
    closeFunc: () => void;
    selectedQuestionsLength: number;
    setSelectedQuestions: Dispatch<SetStateAction<InterviewQuestionForEdit[]>>;
    setDefaultQuestions: Dispatch<SetStateAction<InterviewQuestionForEdit[]>>;
};

export default function RecruitingInterviewDefaults(props: Props) {
    const [selectedQuestionsState, setSelectedQuestionsState] = useState<InterviewQuestionForEdit[]>([]);
    const { questions, closeFunc, setDefaultQuestions, setSelectedQuestions, selectedQuestionsLength } = props;

    const handleSelectQuestion = (question: InterviewQuestionForEdit) => {
        if (selectedQuestionsState.some(q => q.id === question.id)) {
            setSelectedQuestionsState(prev => prev.filter(q => q.id !== question.id));
        } else {
            if (selectedQuestionsState.length + selectedQuestionsLength > 11) return;
            setSelectedQuestionsState(prev => [...prev, question]);
        }
    }

    const handleAddQuestion = () => {
        setSelectedQuestions(prev => [...prev, ...selectedQuestionsState]);
        setDefaultQuestions(prev => prev.filter(i => !selectedQuestionsState.some(q => q.id === i.id)));
        closeFunc();
    };

    return (
        <Modal
            size='md'
            title='Add from suggested list'
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={closeFunc}
        >
            <div className={styles.list}>
                {questions.map(item => <CheckBox
                    text={item.question}
                    checked={selectedQuestionsState.some(q => q.id === item.id)}
                    onClick={() => handleSelectQuestion(item)}
                />)}
            </div>
            <Button
                text='Add'
                type='Primary'
                onClick={handleAddQuestion}
            />
        </Modal>
    )
}
